import React from "react";
import { List } from "web-ui";

import type { TtsRequestParameters } from "../api/duolingoTts";
import { getPreviousVersions } from "../api/transcription";
import type { AnnotationVersionResponseItem } from "../api/transcription";

const PREVIOUS_VERSIONS = "Previous versions:";

export const PreviousVersionList = ({
  ttsItem,
  setVersion,
  forceNewDataKey,
}: {
  ttsItem: TtsRequestParameters;
  setVersion: (version: number | "generated") => void;
  forceNewDataKey?: number;
}) => {
  const [previousVersions, setPreviousVersions] = React.useState<
    AnnotationVersionResponseItem[]
  >([]);
  const [selectedIndex, setSelectedIndex] = React.useState(0);

  const formatDate = (version: AnnotationVersionResponseItem) =>
    new Date(version.last_modified * 1000).toLocaleString();

  React.useEffect(() => {
    (async () => {
      if (ttsItem.has_speech_annotation) {
        const versions = await getPreviousVersions(ttsItem.tts_hash);
        versions.sort((a, b) => b.last_modified - a.last_modified);
        setPreviousVersions(versions);
      }
    })();
  }, [ttsItem, forceNewDataKey]);

  return previousVersions.length > 0 ? (
    <>
      <h2>{PREVIOUS_VERSIONS}</h2>
      <List
        items={previousVersions.map(version => ({
          description: formatDate(version),
          text: version.version.toString(),
        }))}
        onChange={e => {
          if (
            e?.selectedIndices?.[0] !== undefined &&
            previousVersions[e.selectedIndices[0]] !== undefined
          ) {
            setVersion(previousVersions[e.selectedIndices[0]].version);
            setSelectedIndex(e.selectedIndices[0]);
          }
        }}
        scrollable={true}
        selectedIndices={[selectedIndex]}
      />
    </>
  ) : null;
};
